import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { frShort } from "@/lib/format";
import PageHeader from "@/components/PageHeader";

const FALLBACK = "https://images.unsplash.com/flagged/photo-1576972405668-2d020a01cbfa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Actualites() {
    const { data: news = [], isLoading } = useQuery({ queryKey: ["news"], queryFn: async () => (await api.get("/news")).data });

    return (
        <div data-testid="actualites-page">
            <PageHeader
                testid="actualites-header"
                overline="Le club bouge"
                title="Actualités"
                subtitle="Toutes les nouvelles du Tennis Club de La Turballe : événements, résultats, vie du club."
            />
            <div className="max-w-6xl mx-auto px-4 md:px-6 py-12">
                {isLoading ? (
                    <p className="text-slate-500 font-mono text-sm">Chargement…</p>
                ) : news.length === 0 ? (
                    <p className="text-slate-500" data-testid="actualites-empty">Aucune actualité pour le moment.</p>
                ) : (
                    <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
                        {news.map((n, i) => (
                            <motion.article
                                key={n.id}
                                data-testid="news-card"
                                initial={{ opacity: 0, y: 14 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: i * 0.05 }}
                            >
                                <Link to={`/actualites/${n.id}`} className="group block brand-card overflow-hidden h-full transition-colors duration-200 hover:border-clay">
                                    <div className="aspect-[16/10] bg-slate-100 overflow-hidden">
                                        <img src={n.image_url || FALLBACK} alt={n.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                                    </div>
                                    <div className="p-5">
                                        <div className="flex items-center gap-3 text-xs">
                                            <span className="font-mono uppercase tracking-widest text-clay">{n.category}</span>
                                            <span className="text-slate-400">{frShort(n.date)}</span>
                                        </div>
                                        <h3 className="mt-2 font-display font-bold text-lg text-navy leading-snug">{n.title}</h3>
                                        <p className="mt-2 text-sm text-slate-500 line-clamp-3">{n.excerpt}</p>
                                        <div className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-navy group-hover:gap-3 transition-all duration-200">
                                            Lire la suite <ArrowRight weight="bold" size={16} />
                                        </div>
                                    </div>
                                </Link>
                            </motion.article>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
